module.exports = __webpack_public_path__ + "fonts/Mulish-Regular.31423d39.ttf";